var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOpusBasics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9259 20.5C37.9259 30.4002 29.9002 38.4259 20 38.4259C10.0998 38.4259 2.07407 30.4002 2.07407 20.5C2.07407 10.5998 10.0998 2.57407 20 2.57407C29.9002 2.57407 37.9259 10.5998 37.9259 20.5ZM40 20.5C40 31.5457 31.0457 40.5 20 40.5C8.9543 40.5 0 31.5457 0 20.5C0 9.4543 8.9543 0.5 20 0.5C31.0457 0.5 40 9.4543 40 20.5ZM23.7037 20.5C23.7037 22.5455 22.0455 24.2037 20 24.2037C17.9545 24.2037 16.2963 22.5455 16.2963 20.5C16.2963 18.4545 17.9545 16.7963 20 16.7963C22.0455 16.7963 23.7037 18.4545 23.7037 20.5ZM25.7778 20.5C25.7778 23.691 23.191 26.2778 20 26.2778C16.809 26.2778 14.2222 23.691 14.2222 20.5C14.2222 17.309 16.809 14.7222 20 14.7222C23.191 14.7222 25.7778 17.309 25.7778 20.5Z",
    fill: "#8DA5BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpusBasics);
export default __webpack_public_path__ + "static/media/icon-opus-basics.b01f4121.svg";
export { ForwardRef as ReactComponent };